import React from 'react';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot
} from '@material-ui/lab';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import Comment from './components/comment/comment';
import Log from './components/log/log';

const Theme = createMuiTheme({
  overrides: {
    MuiTimeline: {
      root: {
        padding: 0
      }
    },

    MuiTimelineItem: {
      missingOppositeContent: {
        '&:before': {
          display: 'none'
        }
      }
    },

    MuiTimelineDot: {
      defaultPrimary: {
        backgroundColor: '#A6E50F',
        margin: 0
      },
      defaultSecondary: {
        backgroundColor: '#3A61A8',
        margin: 0
      }
    },

    MuiTimelineConnector: {
      root: {
        width: '1px',
        background: '#DBE4F0 0% 0% no-repeat padding-box',
        backgroundColor: '#DBE4F0',
        opacity: 1
      }
    },

    MuiTimelineContent: {
      root: {
        padding: '6px 10px'
      }
    }
  }
});

const CommentContainer = ({ comments, image, myForms, driverPermit }) => (
    <ThemeProvider theme={Theme}>
      <Timeline>
        {comments && comments.map(value => (
              <>{
                driverPermit && (
                <TimelineItem key={value.id}>
                  <TimelineSeparator>
                    <TimelineDot color={'secondary'} />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                  {(value?.classifier === undefined) ? (
                    <Comment
                      key={value.id} comment={value?.tenant ? { ...value, current_date: value?.created_at }:value}
                      driverPermit={driverPermit}
                      additionalInfo={{
                        step_title: value?.step_title
                      }}
                    />
                  ) : (
                    <Log key={value.id} log={value} image={image} />
                  )}
                  </TimelineContent>
                </TimelineItem>)
              }
              {(!myForms && !driverPermit) && (
                <>
                  <TimelineItem key={value.id}>
                    <TimelineSeparator>
                      <TimelineDot color={'secondary'} />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      { value.classifier === undefined &&(
                        <Log key={value.id} log={value} image={image} />
                      )}
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem key={value.id}>
                  <TimelineSeparator>
                    <TimelineDot color={'primary'} />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    {value.classifier === undefined &&(
                      <>
                      <Comment key={value.id} comment={value} />
                      </>
                    )}
                  </TimelineContent>
                  </TimelineItem>
                </>
              )}
              {myForms
                && value?.form_dict?.remarks && (
                  <>
                    <TimelineItem key={value.id}>
                      <TimelineSeparator>
                        <TimelineDot color={'secondary'} />
                        <TimelineConnector />
                      </TimelineSeparator>
                      <TimelineContent>
                        {/* { value.classifier === undefined &&( */}
                          <Log key={value.id} log={value} image={image} myForms />
                        {/* )} */}
                        <Comment
                          key={value.id}
                          comment={
                            { commented_by: { fullname: value?.form_dict?.user },
                              comment: value?.form_dict?.remarks,
                              date: value?.date,
                              image: value?.form_dict?.image
                            }
                          }
                          myForms
                        />
                      </TimelineContent>
                      { value.classifier === undefined &&(
                        <Log key={value.id} log={value} image={image} />
                      )}
                    </TimelineItem>
                  </>
                )}
              </>
            ))}
      </Timeline>
    </ThemeProvider>
  );

export default CommentContainer;
